export default __webpack_public_path__ + "static/media/welcome_screen.e2ec7337.png";